import PageFooter from '@media-ui/core/src/components/Footer';
import Hr from '@media-ui/core/src/components/Hr';
import { IFooterLink } from '@media-ui/core/src/components/Footer/Footer.types';
import * as s from './Footer.css';
const leftLinks: IFooterLink[] = [
    {
        text: 'Mail',
        href: 'https://mail.ru',
        target: '_blank',
    },
    {
        text: 'О компании',
        href: 'https://vk.company/ru/',
        target: '_blank',
    },
];
const rightLinks: IFooterLink[] = [
    {
        type: 'link-cell',
        href: 'https://pets.mail.ru/editorial-staff/',
        text: 'Редакция',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://pets.mail.ru/consultation/all/',
        text: 'Наши эксперты',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://help.mail.ru/legal/terms/pets/policy',
        text: 'Условия использования материалов',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://help.mail.ru/legal/terms/common/mediarecommendation',
        text: 'О технологиях рекомендаций',
        target: '_blank',
    },
    {
        text: 'Политика конфиденциальности',
        href: 'https://help.mail.ru/legal/terms/common/privacy/',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://help.mail.ru/pets_support',
        text: 'Обратная связь',
        target: '_blank',
    },
    {
        type: 'link-cell',
        href: 'https://help.mail.ru/pets_support/consultant',
        text: 'Стать консультантом',
        target: '_blank',
    },
];
const Footer = () => {
    return (<div className={s.footer}>
      <Hr className={s.footerHr}/>
      <div className="lazy" data-rb-slot="recommendationFeed">
        <span suppressHydrationWarning dangerouslySetInnerHTML={{
            __html: `<!-- /mortice/block-recommendation-feed/ --><!--# include virtual="/mortice/block-recommendation-feed/" wait="yes" --><!--// /mortice/block-recommendation-feed/ -->`,
        }}/>
      </div>
      <PageFooter leftPart={leftLinks} rightPart={rightLinks}/>
    </div>);
};
export default Footer;
